module.exports = __webpack_public_path__ + "static/media/Anticelulitidni_gel_retina_kosik.45b9a979.jpg";